export enum ViewType {
  Org = 'Org',
  Mine = 'Mine',
}
